import $ from 'jquery';
import 'jquery-mask-plugin';
import 'breaky';
import './modules.scss';
import './accordion';
import './dropdown';
import './cookies-banner';
import './reveal';
import './responsive';
import './back-button';
import './toggle-display';
import './nav-accordion';
import './truncate';
import './product-size-change';
import './product-add-to-bag';
import './product-color-change';
import './product-oos';
import './product-remove-item';
import './switch-class';
import './hamburger';
import './fixed-overlay';
import './fixed-scroll';
import './back-to-top';
import './product-zoom';
import ImageCarousel from './image-carousel';
import './ui-tabs';
import './modal';
import './submit-modal';
import './track-video';
import './search';
import noFocus from './no-focus';
import './focus-to';
import './slides';
import './side-cart';
import './goto-slide';
import sizeguideTable from './sizeguide';
import './slick-carousel';
import Keyboard from './keyboard';


// Jon to move into its own module and follow standards
$.fn.navDropdowns = function navDropdowns() {
  function toggleDropdown($el) {
    $el.find('ul').slideToggle('slow');
  }

  // Iterate and reformat each matched element.
  return this.each(function reformat() {
    $(this).on('click', function setupToggle() {
      toggleDropdown($(this));
    });
  });
};
window.applyTelephoneMask = () => {
  $('.js-mask-tel-us').each(function maskTelephoneNum() {
    const $el = $(this);
    // const re = new RegExp('^(d{3})sd{3}-d{4,}$');
    const options = {
      onKeyPress: () => {
        if ($el.val().length >= 15) {
          $el.mask('000000000000000', options);
        } else if ($el.val().length === 10) {
          $el.mask('(000) 000-00000', options);
        }
      },
    };
    $el.mask('(000) 000-00000', options);
  });
};
const resetReveals = () => {
  const $resettableReveal = $('.checkout__section-content .js-reveal-is-resettable.reveal-is-active');
  $resettableReveal.each(function closeChildReveals() {
    $(this).reveal('forceToggle');
  });
};
const disableReviewOrder = ($el) => {
  const $reviewTrigger = $('.js-checkout-review-section-trigger');
  $('.js-checkout-section-heds').removeClass('reveal-is-active');
  $el.closest('.js-checkout-section-heds').addClass('reveal-is-active');
  if (!$el.is($reviewTrigger)) {
    $reviewTrigger.reveal('disable');
    $('.js-tablet-place-order').addClass('u-hide');
    $('.js-checkout-total').removeClass('is-grand');
  }
};
const initReveals = () => {
  $('.js-reveal').reveal();
  $('.js-new-shipping-reveal').reveal({
    onOpen: () => {
      $('.js-checkout-shipping-detail-ctas').slideUp(275);
    },
    onClose: () => {
      $('.js-checkout-shipping-detail-ctas').slideDown(275);
    },
  });
  $('.js-new-shipping-reveal-cancel').reveal({
    onOpen: () => {
      resetReveals();
    },
    onClose: () => {
      $('.js-checkout-shipping-detail-ctas').slideDown(275);
    },
  });
  $('.js-new-payment-reveal').reveal({
    onOpen: () => {
      $('.js-checkout-payment-detail-ctas').slideUp(275);
    },
    onClose: () => {
      $('.js-checkout-payment-detail-ctas').slideDown(275);
    },
  });
  $('.js-new-payment-reveal-cancel').reveal({
    onOpen: () => {
      resetReveals();
    },
    onClose: () => {
      $('.js-checkout-payment-detail-ctas').slideDown(275);
    },
  });
  $('.js-billing-address-reveal').reveal({
    onOpen: () => {
      $('.js-billing-address').addClass('reveal-is-active');
    },
    onClose: () => {
      $('.js-billing-address').removeClass('reveal-is-active');
    },
  });
  $('.js-section-reveal').reveal({
    onOpen: ($el) => {
      resetReveals();
      disableReviewOrder($el);
    },
  });
};
const imageCarousel = () => {
  const IMAGE_CAROUSEL_SELECTOR = '.image-carousel';
  const PRODUCT_ZOOM_SELECTOR = `${IMAGE_CAROUSEL_SELECTOR}--product-zoom`;
  const $imageCarousel = $(IMAGE_CAROUSEL_SELECTOR);

  $imageCarousel
    .filter(`:not(${PRODUCT_ZOOM_SELECTOR})`)
    .imageCarousel();

  $imageCarousel
    .filter(PRODUCT_ZOOM_SELECTOR)
    .each(function setupZoomCarousel() {
      const carousel = new ImageCarousel(this, {
        slidesToShow: 2,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
      $(this).productZoom({
        slideFunc: carousel.setSlideNumber.bind(carousel),
        beforeUnmount: carousel.transitionSlide.bind(carousel),
        targetSelector: 'img',
      });
    });

  $imageCarousel.on('click keyup', '.slick-active', function (e) {
    e.stopPropagation();
    if (e.key === 'Enter') {
      $(this).find('img').trigger('click');
    }
    Keyboard.trapFocus($('.dialog__container.pdp__dialog'));
    $('#close-zoom-menu').trigger('focus');
  });

  $('body').on('click', '#close-zoom-menu', () => {
    Keyboard.releaseFocus($('.dialog__container.pdp__dialog'), $imageCarousel);
  });

  $(document).on('keyup', (e) => {
    if (e.key === 'Escape' || e.keyCode === '27') {
      $('#close-zoom-menu').trigger('click');
    }
  });

  $('.slick-slide .zoom-btn').attr('tabindex', -1);
  $('.slick-slide.slick-active .zoom-btn').attr('tabindex', 0);

  $imageCarousel.on('afterChange', () => {
    $('.slick-slide .zoom-btn').attr('tabindex', -1);
    $('.slick-slide.slick-active .zoom-btn').attr('tabindex', 0);
  });

  setTimeout(() => $('.image-carousel .zoom-btn').removeClass('visible'), 1500);
};

const searchFieldClearCloseIconA11y = () => {
  const searchField = $('#desktopSearchInput');
  /* Need timeout because el is not existing/appended yet (iconify-icons). */
  setTimeout(() => {
    searchField.next().find('title').first()
    .text('Close Search');
  }, 250);
  searchField.on('keyup', () => {
    if (searchField.val() === '') {
      searchField.next().find('title').first()
      .text('Close Search');
    } else {
      searchField.next().find('title').first()
      .text('Clear');
    }
  });
};

const removeWhiteSpacesAndLowerCase = () => {
  $('button[data-level="1"], button[data-level="2"]').each(function () {
    let cat = $(this).attr('aria-controls');
    cat = cat.replace(/ /g, '-').toLowerCase();
    cat = `${cat}-container`;
    $(this).attr('aria-controls', cat);
    $(this).next('ul').attr('id', cat);
  });
};

/*
// need to come back to this in another task.
const fixedButtonScroll = () => {
  const el = $('.js-fixed-scroll-desktop');
  const parentWidth = el.parent().width();
  // Who's the element's next element in HTML
  // const next = $('.pdp__prod-recs');
  const elOrgY = el.offset().top;
  // const elH = el.outerHeight(true);
  // Space between element and top of screen (when scrolling)
  const topMargin = 20;
  // const position = el.offset().top - $(window).scrollTop();
  // el.css('position', 'relative');
  // if (el.css('position') !== 'fixed' && position === 0) {
  //   el.css('position', 'fixed');
  // }

  $(window).on('scroll', () => {
    const scrollTop = $(window).scrollTop();
    // const elNewTop = (scrollTop - elOrgY) + topMargin;
    // const nextViewportY = next[0].getBoundingClientRect().top;
    // Return only 0 or negative numbers
    // const subtractToTop = Math.min(0, nextViewportY - (elH + topMargin));
    // console.log();
    if (scrollTop > elOrgY + topMargin) {
      el.css({ position: 'fixed', width: parentWidth, top: topMargin });
    } else {
      el.css({ position: 'relative' });
    }
    // el.css({ top: scrollTop < elOrgY - topMargin ? 0 : elNewTop + subtractToTop });
  });
};
*/
$(document).ready(() => {
  $('#js-nav-dropdown').navDropdowns();
  $('#js-nav-dropdown--full').navDropdowns();
  $('.js-dropdown').dropdown();
  $('.js-accordion').accordion();
  $('.js-nav-accordion').navAccordion();
  $('.ui-tabs').tabs();
  $('.js-toggle-display').toggleDisplay();
  $('.js-modal').modal();
  $('.js-track-video').trackVideo();
  $('.submit-modal').submitModal();
  $('[data-truncate]').truncate();
  $('.back-button').backButton();
  $('.js-responsive').responsive();
  $('.js-cookies-banner-toggle').cookiesBanner();
  $('.js-fixed-overlay').fixedOverlay();
  $('.js-fixed-scroll').fixedScroll();
  $('.js-back-to-top').backToTop();
  $('.js-switch-class').switchClass();
  $('.js-hamburger').hamburger();
  $('.js-item-wrapper').removeItem();
  $('#js-bag-btn').sideCart();
  $('.js-slides').slides();
  $('.js-pdp-zoom').slides({
    prevArrow: $('#js-pdp-zoom-prev'),
    nextArrow: $('#js-pdp-zoom-next'),
  });
  $('.js-goto-slide').gotoSlide();
  noFocus();
  initReveals();
  imageCarousel();
  sizeguideTable();
  window.applyTelephoneMask();
  // fixedButtonScroll();
  if ($('.js-lazy-scroll').length) {
    $('.js-lazy-scroll').lazy();
  }
  $('.js-focus-to').focusTo();
  searchFieldClearCloseIconA11y();
  removeWhiteSpacesAndLowerCase();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/modules.js